'use strict';

var rUpper = /([A-Z])/g;

module.exports = function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dom-helpers/util/hyphenate.js
 ** module id = 300
 ** module chunks = 0
 **/